<template>
  <div>
    <option-search v-if="value == null" :options="options" v-model="searchText"
                   :labelpath="labelpath" :keypath="keypath" @select="updateModel"
                   :minchars="minchars" :error-messages="errorMessages"/>
    <v-subheader v-else>
      {{ label }}
      <v-btn icon @click="clearModel">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-subheader>
  </div>
</template>

<script>
  import OptionSearch from './OptionSearch';

  export default {
    components: { OptionSearch },
    props: ['value', 'options', 'labelpath', 'keypath', 'minchars', 'errorMessages'],
    data() {
      return {
        searchText: ''
      };
    },
    watch: {
      value(val) {
        if (!val) {
          this.searchText = '';
        }
      }
    },
    computed: {
      label() {
        const filtered = this.options
          .filter((o) => this.getKey(o) === this.value)
          .map((o) => this.labelpath ? o[this.labelpath] : o);
        return filtered.length ? filtered[0] : this.value;
      }
    },
    methods: {
      getKey(item) {
        return this.keypath ? item[this.keypath] : item;
      },
      updateModel(val) {
        this.$emit('input', this.keypath ? val[this.keypath] : val);
      },
      clearModel() {
        this.searchText = '';
        this.$emit('input', null);
      }
    }
  };
</script>

<style scoped>

</style>
